
import React, { Component } from 'react'
import { Card, notification, Space, Upload, Button } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import Http from '../../../utils/http'
import Slider from 'react-slick'

class WeightBalance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      tab: 'oew'
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = async () => {
    try {
      Http.get('/w_b/oew').then((response) => {
        this.setState({ data: response.data.data })
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching data:', error)
    }
  }

  oew = () => {
    return (
      <div>
        <h3>OEW</h3>
        <Space direction='horizontal' size={0} className='ml-auto d-flex'>
          <Upload
            accept='.xlsx,.xls'
            showUploadList={false}
            beforeUpload={(file) => {
              const formData = new FormData()
              formData.append('file', file)

              Http.post(
                '/w_b/oew',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                    'station': this.state.station
                  }
                }
              ).then((data) => {
                if (data && data?.status === 200) {
                  notification.destroy()
                  notification.success({
                    message: 'Success',
                    description: data?.data?.message,
                  })
                  this.fetchData()
                } else {
                  notification.destroy()
                  notification.error({
                    message: 'Failed',
                    description: data?.data?.message,
                  })
                }
              }).catch((err) => {
                notification.destroy()
                notification.error({
                  message: 'Failed',
                  description: err?.response?.data?.message || 'Something went wrong',
                })
              })


              return false // prevent default upload
            }}
          >
            <Button type='link' className='link-btn-dod uld-upload' icon={<UploadOutlined style={{ fontSize: 16 }} />}>Upload</Button>
          </Upload>
        </Space>
        <table className='table table-bordered'>
          <thead>
            <tr>
              <th>Aircraft Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {this.state.data.map((item, index) => (
              <tr key={index}>
                <td>{item.type}</td>
                <td>{item.oew.map(value => {
                  const extraColums = []
                  const keys = Object.keys(value)
                  keys.forEach(key => {
                    if (!['ship', 'dom_oew_adj_wt', 'intl_oew_adj_wt', 'config'].includes(key)) {
                      extraColums.push({ [key]: value[key] })
                    }
                  })
                  return (
                    <table key={value.id}>
                      <thead>
                        <tr>
                          <th>Ship</th>
                          <th>Dom OEW Adj Wt</th>
                          <th>Intl OEW Adj Wt</th>
                          <th>Config</th>
                          {extraColums.map(col => {
                            const colName = Object.keys(col)[0]
                            return <th key={colName}>{colName}</th>
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{value.ship}</td>
                          <td>{value.dom_oew_adj_wt}</td>
                          <td>{value.intl_oew_adj_wt}</td>
                          <td>{value.config}</td>
                          {extraColums.map(col => {
                            const colName = Object.keys(col)[0]
                            return <td key={colName}>{col[colName]}</td>
                          })}
                        </tr>
                      </tbody>
                    </table>
                  )
                })}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    // const { data } = this.state
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      // slidesToShow: 7,
      slidesToShow: 9,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
      ]
    }
    return (
      <div>
        <div>
          <Slider {...settings} className='custom-slider sys-para-slider mb-24px'>
            <div className={`tabs ${this.state.tab === 'oew' ? 'active-tab' : ''}`} onClick={() => this.setState({ tab: 'oew' })}>
              <span>OEW</span>
            </div>
          </Slider>
        </div>
        <div className='table-responsive'>
          <Card className='custom-card'>
            {this.state.tab === 'oew' && this.oew()}
          </Card>
        </div>
      </div>
    )
  }
}


export default WeightBalance